import { render } from "./CreatorHeader.vue?vue&type=template&id=39ac711b"
import script from "./CreatorHeader.vue?vue&type=script&lang=js"
export * from "./CreatorHeader.vue?vue&type=script&lang=js"

import "./CreatorHeader.vue?vue&type=style&index=0&id=39ac711b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__